export enum STATSIG_EXPERIMENTS {
  FLIGHTS_BY_SECTOR = 'travel_flight_by_sector',
  FEE_SENSITIVITY = 'travel_fee_sensitivity',
  TRAVEL_MAINTENANCE_PAGE = 'travel_maintenance_page',
  CABIFY_VOUCHER = 'travel_cabify_voucher',
  FLIGHT_UPSELL = 'travel_flight_upsell'
}
